const formatBirthday = (date: Date | string | undefined) => {
  if (!date) return "";

  if (typeof date === "string") {
    if (/^\d{4}-\d{2}-\d{2}/.test(date)) {
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    }
    return date;
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export default formatBirthday;
